/* eslint-disable react/forbid-prop-types */
import React from 'react';
import * as XLSX from 'xlsx';
import { Row, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { setCurrencyFormat } from '../../../../utils/helpers';
import ResizableDataTable from '../../../Tables/ResizableTable/components/ResizableReactTable';


const InventoryFBAForecastTable = ({ data, tableHeaderData, prepareStocks }) => {

    const excelData = data.map((item) => {
        const updated = { ...item };
        const { inboundWorkingQty, inboundTotal, reserved, unfulfillable, researching, totalInventory,
            soldQty, averageDailySoldQty, inventoryLeft, fulFillableQty, inboundReceivingQuantity,
            inboundShippedQuantity,soldQty7Days,velocity } = updated;
        const qtyToSend = Number(Number(prepareStocks - inventoryLeft) * Number(averageDailySoldQty));

        updated.inboundWorkingQty = setCurrencyFormat(Number(inboundWorkingQty).toFixed(0), false);
        updated.inboundTotal = setCurrencyFormat(Number(inboundTotal).toFixed(0), false);
        updated.reserved = setCurrencyFormat(Number(reserved).toFixed(0), false);
        updated.unfulfillable = setCurrencyFormat(Number(unfulfillable).toFixed(0), false);
        updated.researching = setCurrencyFormat(Number(researching).toFixed(0), false);
        updated.totalInventory = setCurrencyFormat(Number(totalInventory).toFixed(0), false);
        updated.soldQty = setCurrencyFormat(Number(soldQty).toFixed(0), false);
        updated.averageDailySoldQty = setCurrencyFormat(Number(averageDailySoldQty).toFixed(10), false);
        updated.inventoryLeft = setCurrencyFormat(Number(inventoryLeft).toFixed(0), false);
        updated.qtyToSend = setCurrencyFormat(Number(qtyToSend < 0 ? 0 : qtyToSend).toFixed(0), false);
        updated.fulFillableQty = setCurrencyFormat(Number(fulFillableQty).toFixed(0), false);
        updated.inboundReceivingQuantity = setCurrencyFormat(Number(inboundReceivingQuantity).toFixed(0), false);
        updated.inboundShippedQuantity = setCurrencyFormat(Number(inboundShippedQuantity).toFixed(0), false);
        updated.soldQty7Days = setCurrencyFormat(Number(soldQty7Days).toFixed(0), false);
        updated.velocity = setCurrencyFormat(Number(velocity).toFixed(0), false);

        return updated

    });

    const handleDownload = () => {
        if (!data.length) return;

        // Create a new workbook
        const wb = XLSX.utils.book_new();
        
        // Create headers array from tableHeaderData
        const headers = tableHeaderData?.map(col => col.Header) || [];
        
        // Create data array with only the fields specified in tableHeaderData
        const worksheetData = excelData?.map(row => {
            const filteredRow = {};
            tableHeaderData?.forEach(col => {
                filteredRow[col.Header] = row[col.accessor];
            });
            return filteredRow;
        }) || [];
        
        // Convert data to worksheet format with proper headers
        const ws = XLSX.utils.json_to_sheet(worksheetData, { header: headers });
        
        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'report');
        
        // Write the file
        XLSX.writeFile(wb, 'FBA Inventory Forecast.xlsx');
    };


    return (
        <Row style={{ position: 'relative' }} className="react-tableHeight">
            <div className="ExcelTable" id='dvTable'>
                 <Button 
                    disabled={!data.length}
                    className="download-monthly-sub-order-report btn-primary btn btn-sm"
                    onClick={handleDownload}
                >
                    Download
                </Button>
            </div>
            <ResizableDataTable customClass="pt-0" reactTableData={{ tableHeaderData }} data={excelData} />
        </Row>
    )
}

InventoryFBAForecastTable.propTypes = {
    data: PropTypes.array.isRequired,
    tableHeaderData: PropTypes.array.isRequired,
    prepareStocks: PropTypes.number.isRequired
};


export default InventoryFBAForecastTable;